export default "__VITE_ASSET__5c9c8911__"